module.exports = __webpack_public_path__ + "static/media/pAVAX.3832b2f1.svg";